import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { baseUrl } from "src/const";
import { appUrl } from "src/const/baseUrl";

export const serverApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: async (headers) => {
      const session = await axios.get(`${appUrl}/api/session`);
      if (session.data?.user.accessKey.value) {
        headers.set(
          "authorization",
          `Bearer ${session?.data.user.accessKey.value}`,
        );
      }

      return headers;
    },
  }),
  endpoints: () => {
    return {};
  },
  // ブラウザの別タブから戻ったときキャッシュを更新
  refetchOnFocus: true,
  reducerPath: "serverApi",
  tagTypes: [
    "User",
    "UsersFollowing",
    "UsersFollower",
    "UsersCoach",
    "UsersAdmin",
    "UsersAll",
    "UsersRecommend",
    "UserSettings",
    "MypageFollowUsers",
    "Session",
    "Sessions",
    "SessionsCalendar",
    "WorkSheet",
    "WorkSheets",
    "Avatar",
    "Fumufumus",
    "FumufumusPublic",
    "FumufumusPrivate",
    "FumufumusChat",
    "FumufumusEvent",
    "FumufumusSession",
    "FumufumusFollow",
    "FumufumusWakaru",
    "FumufumusSearch",
    "FumufumusDraft",
    "MyFumufumus",
    "Maps",
    "Points",
    "Missions",
    "RankingsAvatarMonthly",
    "RankingsAvatarTotal",
    "RankingsFumufumuTotal",
    "Challenges",
    "ChallengesHistory",
    "ChallengesHistoryChat",
    "Minds",
    "MindsHistory",
    "UserActivities",
    "MyActivities",
    "MypageFollowUsers",
    "Tutoreails",

    // コーチ用
    "CoachSessions",
    "CoachWorkSheets",

    //運営用
    "SessionBases",
    "SessionCategory",
    "Course",
    "Period",
    "Venue",
    "unappovedUsers",
    "unappovedCoaches",

    "Entry",
    "InvitationCode",
    "EntryDatetime",

    "NotificationUser",
    "FavoriteUser",
    "FavoriteQuarterlyRankings",
    "UsersClassmate",
    "FavoriteUserListByAdmin",
    "FindFavoriteUser",
    "UserSessions",
    "UserRescheduleSessions",
    "NotificationBadgeCount",
    "UserCareerProfile",
    "UserCareerProfiles",
    "Payment",
    "CoachSession",
    "EligibleUsersForSession",
    "EligiblefumufumusForSession",
    "Organization",
    "NotificationTriggers",
    "NotificationTrigger",
    "EmailSuppressedDestinations",
    "Organizations",
    "Organization",
  ],
});
